import axios from 'axios';
import Cookies from 'js-cookie';
import { API_BASE_URL } from '../constants/configuration';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: true,       
});

apiClient.interceptors.request.use(config => {
  return config;
});

export default apiClient;
